<div class="index-watch-dialog-container border-box fill-height full-width display-flex-column">
    <!-- Header -->
    <div class="dialog-header flex-space-between align-items-center padding">
        <h2 class="dialog-title font-14 font-bold primary-dark-text no-margin">Customize Ticker</h2>
        <button mat-icon-button class="close-button" (click)="closeDialog()">
          <mat-icon class="font-12">close</mat-icon>
        </button>
      </div>

    <!-- Tutorial Overlay -->
    <div *ngIf="isFirstTimeUser && tutorialGif !== ''" class="tutorial-overlay flex-centered-container dark-backdrop">
        <div class="tutorial-content width-90 text-center pad-32">
            <h3 class="tutorial-heading font-24">Pin Your Favorite Indices</h3>
            <p>Drag your favorite indices to the top of the list to pin them!</p>
            <img [src]="tutorialGif" alt="Drag to pin tutorial" class="tutorial-gif full-width">
            <button mat-flat-button color="accent" class="got-it-button margin-top full-width font-16 text-uppercase" (click)="dismissTutorial(); preventEvent($event)">Got it!</button>
        </div>
    </div>

    <!-- Content Container -->
    <div class="dialog-content overflow-auto padding">
        <div class="symbols-list-container" cdkDropList (cdkDropListDropped)="drop($event)">
            <div *ngFor="let symbol of workingIndexSymbols" class="symbol-card" cdkDrag>
                <div class="symbol-card-content flex-space-between align-items-center">
                    <!-- Left: Symbol Name -->
                    <div class="symbol-details flex-centered-container-vr gap-8-px">
                        <mat-icon class="drag-handle placeholder-text" cdkDragHandle>drag_handle</mat-icon>
                        <div class="symbol-name font-14 primary-dark-text">
                            {{symbol.value.title}}
                        </div>
                    </div>

                    <!-- Right: Price Details -->
                    <div class="symbol-details flex-centered-container-vr gap-8-px">
                        <!-- LTP -->
                        <div class="symbol-price font-12" [ngClass]="getClass(symbol.value.changeInPrice)">
                            {{symbol.value.ltp | localeConverter: 2: true: true | nullCheck}}
                        </div>

                        <!-- Change Box with Percentage -->
                        <div class="font-10 flex-centered-container change-box" 
                             [ngClass]="{'change-percent-positive-box': symbol.value.changeInPrice >= 0, 'change-percent-negative-box': symbol.value.changeInPrice < 0}">
                            {{symbol.value.changeInPrice | localeConverter: 2: true: true | nullCheck}}
                            ({{symbol.value.changePercent | localeConverter: 2: true: true | percentPipe: 1 | nullCheck}})
                        </div>

                        <!-- Arrow Icon -->
                        <mat-icon class="arrow-icon" 
                                  [ngClass]="{'text-green': symbol.value.changeInPrice >= 0, 'text-negative-change': symbol.value.changeInPrice < 0}">
                            {{symbol.value.changeInPrice >= 0 ? 'arrow_drop_up' : 'arrow_drop_down'}}
                        </mat-icon>

                        <!-- Drag Handle (Menu Icon) - Placeholder for later -->
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Footer with Save button -->
    <div class="dialog-footer flex-centered-container padding border-top">
        <button mat-flat-button color="accent" class="new-submit-button full-width" (click)="closeDialog(true)">
            Save & Continue
        </button>
    </div>
</div>

